/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramChatsUserControllerFindOneQueryResponse,
  TelegramChatsUserControllerFindOnePathParams,
  TelegramChatsUserControllerFindOne401,
  TelegramChatsUserControllerFindOne403,
  TelegramChatsUserControllerFindOne404,
} from '../types/TelegramChatsUserControllerFindOne.ts';

function getTelegramChatsUserFindOneUrl(id: TelegramChatsUserControllerFindOnePathParams['id']) {
  const res = { method: 'GET', url: `/api/user/telegram/chats/${id}` as const };
  return res;
}

/**
 * {@link /api/user/telegram/chats/:id}
 */
export async function telegramChatsUserFindOne(
  id: TelegramChatsUserControllerFindOnePathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramChatsUserControllerFindOneQueryResponse,
    ResponseErrorConfig<
      | TelegramChatsUserControllerFindOne401
      | TelegramChatsUserControllerFindOne403
      | TelegramChatsUserControllerFindOne404
    >,
    unknown
  >({ method: 'GET', url: getTelegramChatsUserFindOneUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
